import React from "react";
import { Link as ChakraLink, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

interface ILinkProps {
  to: string;
  children: React.ReactNode;
}
export default function Link({ to, children }: ILinkProps) {
  return (
    <ChakraLink as={RouterLink} to={to}>
      <Text fontWeight="bold" color="black.500">
        {children}
      </Text>
    </ChakraLink>
  );
}
